import React from 'react';
import Chip from '../shared/Chip';
import { ASSESSMENT_STATUS } from '../../../models/AssessmentsModel';

/*
 * The five states on the shared Chip (PRD-1703). Uploading and Queued are
 * Standard, Uploading carrying its percentage with no bar; Processing,
 * Completed and Failed are processing, success and error. An archived
 * assessment keeps the status it had, faded with its card or row.
 */
function AssessmentStatusChip({ assessment }) {
  const meta = ASSESSMENT_STATUS[assessment.status] || { label: assessment.status, variant: 'standard' };
  const progress = assessment.status === 'uploading' ? ` ${Math.round(assessment.progress || 0)}%` : '';
  return <Chip variant={meta.variant}>{`${meta.label}${progress}`}</Chip>;
}

export default AssessmentStatusChip;
